<template>
  <fo-layout class="white-bg">
    <div class="about-bigbox" v-if="loading">
      <div class="about-content">
        <div class="about-img">
          <div class="about-not"></div>
          <div class="backimg"></div>
        </div>
        <div class="about-blue-color">
          <div class="about-bar">
            <p class="primary title-alt to-1">
              <span class="dis-bl ht-20 gray-bg mb-10"></span>
            </p>
            <p class="primary title to-1">
              <span class="dis-bl ht-40 gray-bg"></span>
            </p>
            <p class="info to-5 pt-20">
              <span class="dis-bl ht-100 gray-bg"></span>
            </p>
            <a-button class="fo-small-btn" type="primary" @click="goToPage">button</a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="about-bigbox" v-else>
      <div class="about-content">
        <div class="about-img">
          <div class="about-not"></div>
          <div class="backimg centerimage"
            :style="'background-image: url(' + item.home_img + ')'"></div>
        </div>
        <div class="about-blue-color">
          <div class="about-bar">
            <p class="primary title-alt to-1">{{item.subtitle}}</p>
            <p class="primary title to-1">{{item.title}}</p>
            <p class="info to-5 pt-20">{{item.infoa}}</p>
            <a-button class="fo-small-btn" type="primary" @click="goToPage">{{item.button_text}}</a-button>
          </div>
        </div>
      </div>
    </div>
  </fo-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      loading: true,
      item: {
        title: '',
        subtitle: '',
        infoa: '',
        infob: '',
        big_img: '',
        small_img: '',
        home_img: ''
      }
    }
  },
  watch: {
    'commonData.web_comp_intro' (obj) {
      this.item = JSON.parse(obj.value)
      this.loading = false
    }
  },
  mounted () {
    if (this.commonData.web_comp_intro.value) {
      this.item = JSON.parse(this.commonData.web_comp_intro.value)
      this.loading = false
    }
  },
  methods: {
    goToPage () {
      window.scroll(0, 0)
      this.$router.push('/about')
    }
  }
}
</script>

<style lang="less">
@import url('../../utils/color.less');
@media screen and (max-width: 751px) and (min-width: 300px) {
  .example1 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 260px 50px;
    margin: 20px 0;
  }
  .about-bigbox{
    max-width: 375px;
    position: relative;
    .about-blue-color {
      .about-bar {
        margin-top: 20px;
        .title-alt {
          font-size: 14px;
          font-family: Georgia, 宋体;
          margin-bottom: 4px;
        }
        .title {
          font-weight: 600;
          font-family: Georgia, 宋体;
          font-size: 28px;
          margin: 0;
        }
      }
    }
      .backimg {
        width: 100%;
        height: 300px;
      }
  }
}
@media screen and (min-width: 751px) {
  .example1 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 360px 50px;
    margin: 20px 0;
  }
  .about-bigbox{
    .about-content {
      position: relative;
      padding-top: 202px;
      padding-right: 120px;
      .about-img {
        .about-not {
          height: 162px;
          width: 162px;
          background-color: @support;
          position: absolute;
          right: 470px;
          top: 470px;
        }
        .backimg {
          background-color: @primary;
          height: 610px;
          width: 610px;
          position: absolute;
          right: 0px;
          top: 0px;
        }
      }
      .about-blue-color {
        background-color: @primary;
        border-top-left-radius: 60px;
        padding-top: 100px;
        padding-right: 580px;
      }
      .about-bar {
        height: 400px;
        background-color: white;
        padding: 50px 50px 0 0;
        .title-alt {
          font-family: Georgia, 宋体;
          font-size: 16px;
          margin: 0;
        }
        .title {
          font-family: Georgia, 宋体;
          font-size: 30px;
          font-weight: bold;
          margin: 0;
        }
        .ant-btn {
          position: absolute;
          bottom: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/about.vue